// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { getOverallUptime } from '../services/supabaseService';
import { Card, CardContent, Typography, CircularProgress } from '@mui/material';

const OverallUptime: React.FC = () => {
    const [overallUptime, setOverallUptime] = useState(0);

    useEffect(() => {
        const fetchOverallUptime = async () => {
            try {
                const currentYear = new Date().getFullYear();
                const uptimeValue = await getOverallUptime(currentYear);

                setOverallUptime(uptimeValue);
            } catch (error) {
                console.error("Failed to fetch overall uptime:", error);
            }
        };

        fetchOverallUptime();
    }, []);

    return (
        <CardContent style={{ textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>Overall Uptime</Typography>
            <div style={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress variant="determinate" value={overallUptime} size={100} thickness={5} />
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}
                >
                    {`${parseFloat(overallUptime).toFixed(2)}%`}
                </Typography>
            </div>
        </CardContent>
    );
};

export default OverallUptime;